/**
 * Who the signed-in student is, for the copies of unfinished work kept in this browser (the practice
 * set, Dagens pass). `AuthProvider` sets it while rendering, before any page reads storage. A copy
 * written by another account (a cookie that expired, then a different student signed in) is ignored
 * and cleared by its reader. Null means nobody is signed in (or the profile is still loading).
 */
let owner: string | null = null;

export function setStorageOwner(userId: string | null): void {
  owner = userId;
}

export function getStorageOwner(): string | null {
  return owner;
}

/**
 * True when a copy stamped `stamped` may be used by the current owner. A copy with no stamp was
 * written before the profile loaded (never by a page behind sign-in), so it cannot be another
 * account's, so it passes unless `strict` (the durable localStorage copy, which outlives a cookie:
 * an unstamped one is foreign once a user is known). With no owner known nothing is checked.
 */
export function belongsToOwner(stamped: unknown, strict = false): boolean {
  if (owner === null) return true;
  if (stamped === null || stamped === undefined) return !strict;
  return stamped === owner;
}
